<template>
    <div class="cb-wizard-step5 cb-wizard__container">
        <div class="cb-wizard__body">
            <div class="cb-wizard__header">
                <h3 class="cb-wizard__title">Good to go!</h3>
                <Stepper class="cb-wizard__stepper"
                    :labels="['Step1', 'Step2', 'Step3', 'Step4', 'Step5']"
                    :currentStep="4" />
            </div>
            <div class="cb-wizard-step5__body">
                <div class="cb-wizard-step5__content">
                    <p class="cb-wizard-step5__title">Your new Content Brief is ready to go!</p>
                    <p class="cb-wizard-step5__text">Some handy things to know:</p>
                    <p class="cb-wizard-step5__text"><strong>Audience Key</strong> integrates helpful workflow features
                        to manage
                        planning and production statuses and assignability. These updates can be made right inside the
                        content brief, including:</p>
                    <ol class="cb-wizard-step5__list">
                        <li>Assigned Writer</li>
                        <li>Writing status</li>
                        <li>Target date</li>
                        <li>Planning status</li>
                        <li>Publishing status</li>
                    </ol>

                </div>
                <div class="cb-wizard-step5__controls">
                    <button class="cb-wizard__button"
                        @click="next">Save and go to content brief</button>
                    <button class="cb-wizard__button cb-wizard__button_inverted"
                        @click="back">Previous</button>
                </div>
            </div>
        </div>
        <div class="cb-wizard__sidebar">
            <div class="cb-wizard-step5__sidebar-content">
                <span class="cb-wizard__sidebar-pro-tip">Pro tip: <base-material-design-icon
                        icon="lightBulbOutline" /></span>
                <ul class="cb-wizard-step5__sidebar-list">
                    <li>
                        Visit the
                        <a class="cb-wizard-step5__link"
                            href="#"
                            target="__blank">Project Membership</a>
                        screen to add new collaborators to your project so they can be assigned.
                    </li>
                    <li>
                        The knowledge center provides details on
                        <a class="cb-wizard-step5__link"
                            href="#"
                            target="_blank">statuses</a>
                        and
                        <a class="cb-wizard-step5__link"
                            href="#"
                            target="_blank">assigning</a>.
                    </li>
                    <li>
                        Add and manage all keywords in your account via the
                        <a class="cb-wizard-step5__link"
                            href="#/strategy/keyword-census"
                            target="_blank">keyword census</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Stepper from './stepper.vue';

export default {
    name: 'ContentBriefWizardStep5',
    props: {
    },
    components: { Stepper },
    methods: {
        next() {
            this.$emit('save');
        },
        back() {
            this.$emit('previous')
        }
    },
}
</script>

<style scoped
    lang="scss">
    .cb-wizard-step5 {
        &__body {
            position: relative;
            height: 100%;
            padding-bottom: 70px;
            box-sizing: border-box;
        }

        &__content {
            width: 554px;
            padding: 40px;
            box-sizing: border-box;
            background-color: $rfx-almost-white-lighter;
            border: 1px solid $rfx-almost-white-darker;
            margin: 0 auto;
        }

        &__title {
            font-size: 18px;
            font-weight: 700;
            margin: 0 0 40px;
        }

        &__text {
            line-height: 20px;
            margin: 20px 0 0;
        }

        &__list {
            margin: 30px 0 0;
            font-weight: 700;

            & > li {
                margin-top: 10px;
            }
        }

        &__link {
            color: $rfx-blue !important;
        }

        &__controls {
            display: flex;
            justify-content: center;
            gap: 20px;
            flex-direction: row-reverse;
            position: absolute;
            bottom: 0;
            width: 100%;
        }

        &__sidebar-content {
            position: absolute;
            bottom: 100px;
            width: 340px;
        }

        &__sidebar-list {
            margin-bottom: 0;
            padding-left: 10px;

            &>li {
                margin-top: 15px;
            }
        }
    }
</style>